<template>
    <div class="numbox" id="number-box">
        <!--  v-for="(item, i) in numArr" :class="{number: true, "lakh": numberData[i].id}" :id="numberData[i].id" -->
        <p id="lakh" class="number " v-for="(item, index) in numArr" :class="{[numberData[numberData.length - (index + 1)].class]: true}">
            <span class="num">0</span>
            <span class="num">1</span>
            <span class="num">2</span>
            <span class="num">3</span>
            <span class="num">4</span>
            <span class="num">5</span>
            <span class="num">6</span>
            <span class="num">7</span>
            <span class="num">8</span>
            <span class="num">9</span>
        </p>
    </div>
</template>

<script>
    export default {
        props:{
            number: {
                type: Number,
                default: 923451
            }
        },
        data(){
            return {
                num: 239092,
                numArr:[],
                numberData: [
                    {
                        class: 'hunTh', //百万
                    },
                    {
                        class: 'lakh', //十万
                    },
                    {
                        class: 'tenTh',  //万位
                    },
                    {
                        class: 'thousand', //千位
                    },
                    {
                        class: 'hundred', //百位
                    },
                    {
                        class: 'decade', //十位
                    },
                    {
                        class: 'util',  //个位
                    }
                ]
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            getNumArr(num){
				return num.toString().split('').map(item => {
                            return parseInt(item);
                        });
			},
            arrEquals(newArr, oldArr) {
				// 变更数字的index
				var changeIndex = []
				for (var i = 0; i <= newArr.length; i++) {
					if(newArr[i] != oldArr[i] ){
						changeIndex.push(i)
					}
				}
				return changeIndex
            },
            init(){
                this.numArr = this.getNumArr(this.number);
                document.getElementById('number-box').style.width = (this.numArr.length * 32) + 'px';
            }
        },
        watch: {
            number(newVal, oldVal) {
                newVal = this.getNumArr(newVal);
                oldVal = this.getNumArr(oldVal);
                var changeIndex = this.arrEquals(newVal, oldVal)
                var top;
                //反向排序，对好位数
                var numbers = Array.from(document.querySelectorAll('.number')).reverse();
                // 初始化，看有几位数字
                document.getElementById('number-box').style.width = (this.numArr.length * 32) + 'px';
                // 变化数字跳动
                for (var i = 0; i < changeIndex.length; i++) {
                    numbers[changeIndex[i]].style.top = (newVal[changeIndex[i]] * -50) + 'px'; 
                } 
            }
        }
        
    }

</script>

<style>
    .util{
		position: absolute;
		right: 0;
        top: -50px;
	}
	.decade{
		position: absolute;
		right: 30px;
        top: -100px;
	}
	.hundred{
		position: absolute;
		right: 60px;
        top: -150px;
	}
	.thousand{
		position: absolute;
		right: 90px;
        top:  -200px;
	}
	.tenTh{
		position: absolute;
		right: 120px;
        top:  -250px;
	}
	.lakh{
		position: absolute;
		right: 150px;
        top:  -300px;
	}
	.number{
        width: 40px;
        display: inline-block;
        -webkit-transition: top .5s ease-out;
        -o-transition: top .5s ease-out;
        transition: top .5s ease-out;
        font-size: 0;
	}
	.num{
        display: inline-block;
        height: 50px;
		font-size: 46px;
		color: #E6CA99;
        line-height: 50px;
        text-align: center;
        font-family: 'DIN-Bold';
	}
    .numbox{
		display: inline-block;
		width: 200px;
		height: 50px;
		overflow: hidden;
		position: relative;
        vertical-align: middle;
        margin-top: 5px;
	}

</style>



// WEBPACK FOOTER //
// NumScroll.vue?5cf33445